import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducers";
import persistState from 'redux-localstorage';
import userManager from "./utils/userManager";
import { loadUser } from "redux-oidc";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancer(
    applyMiddleware(thunk),
    persistState(),
);

const store = createStore(reducer, enhancer);
loadUser(store, userManager);

export default store;
